const r=(r,t)=>{const o={};for(const c of new Set([...Object.keys(t),...Object.keys(r)])){const e=r[c],s=t[c];Array.isArray(e)&&Array.isArray(s)?o[c]=e.concat(s):o[c]=void 0!==s?s:e}return[o]};export{r as mergeWith};
